/**
 * A large paste becomes a text attachment instead of filling the composer (ADMIN-212), as in
 * Claude: the message stays readable and the model gets the text whole (the API inlines text
 * attachments, `inlineTextAttachments` in the chat turn).
 */

/**
 * A paste this long, in characters or lines, goes in as a file.
 *
 * @public exported for its test
 */
export const LARGE_PASTE_CHARS = 4000;
/** @public exported for its test */
export const LARGE_PASTE_LINES = 60;

export function isLargePaste(text: string): boolean {
  if (text.length >= LARGE_PASTE_CHARS) return true;
  let lines = 1;
  for (let i = 0; i < text.length; i++) {
    if (text.charCodeAt(i) === 10 && ++lines >= LARGE_PASTE_LINES) return true;
  }
  return false;
}

/** The file a large paste becomes: "Pasted text.txt", then "Pasted text 2.txt" and so on. */
export function pastedTextFile(text: string, existingNames: readonly string[] = []): File {
  let name = "Pasted text.txt";
  for (let n = 2; existingNames.includes(name); n++) name = `Pasted text ${n}.txt`;
  return new File([text], name, { type: "text/plain" });
}
